"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var injectStyleProp_1 = require("../utils/injectStyleProp");
var IconSizesEnum_1 = require("../enums/IconSizesEnum");
var defaultProps = {
    value: false,
    size: IconSizesEnum_1.IconSizesEnum.medium,
    tintColor: undefined
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
var StyledIcon = native_1.default(react_native_1.Image)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\twidth: ", "px;\n\theight: ", "px;\n\tresize-mode: contain;\n"], ["\n\t", ";\n\twidth: ", "px;\n\theight: ", "px;\n\tresize-mode: contain;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), injectStyleProp_1.injectStyleProp('tint-color'), function (props) { return props.size; }, function (props) { return props.size; });
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLAtomButtonToggle = function (_a) {
    var value = _a.value, onChange = _a.onChange, activeImage = _a.activeImage, inactiveImage = _a.inactiveImage, size = _a.size, tintColor = _a.tintColor;
    // Renders an icon (both active and inactive, the image is a parameter)
    var renderIcon = function (iconImage) { return (react_1.default.createElement(StyledIcon, { source: iconImage, tintColor: tintColor, size: size })); };
    // Function that receives a boolean value
    var onPress = function () {
        onChange && onChange(value || false);
    };
    // Returns complete ATLAtomButtonToggle
    return (react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { onPress: onPress }, value ? renderIcon(activeImage) : renderIcon(inactiveImage)));
};
exports.ATLAtomButtonToggle.defaultProps = defaultProps;
exports.ATLAtomButtonToggle.displayName = 'ATLAtomButtonToggle';
var templateObject_1;
